module.exports = {"title":"Total a receber (R$) em out/17 19:32 - 22/10/17"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/DashboardResume/receipts/data.json
// module id = 2246
// module chunks = 0